import ScanIconSvg from '../../../svgs/ScanIconSvg';

import styles from './index.module.scss';

const EmptyInCart = () => {
	return (
		<div className="d-flex flex-column justify-content-center align-items-center my-4" style={{ height: '58vh' }}>
			<div className="my-2">
				<ScanIconSvg />
			</div>
			<div className={`${styles.text} text-center`}>
				<span>Search or Scan to add a product</span>
			</div>
		</div>
	);
};

export default EmptyInCart;
